import { createTheme } from '@mui/material/styles';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { PropsWithChildren } from 'react';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#0057B8', // Azul Royal - Segurança e tecnologia
//     },
//     secondary: {
//       main: '#28A745', // Verde Esmeralda - Dinheiro e transações bem-sucedidas
//     },
//     warning: {
//       main: '#F4B400', // Dourado Suave - Valor e prestígio
//     },
//     background: {
//       default: '#F5F5F5', // Fundo cinza claro para suavidade
//       paper: '#FFFFFF', // Branco para contrastes limpos
//     },
//     text: {
//       primary: '#333F48', // Cinza Grafite - Seriedade e profissionalismo
//       secondary: '#28A745', // Verde - Chamadas de atenção financeiras
//     },
//   },
//   typography: {
//     fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
//   },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 8,
//           textTransform: 'none',
//           fontWeight: 'bold',
//         },
//       },
//     },
//   },
// });


const theme = createTheme({
  palette: {
    primary: {
      main: "#0A3D62", // Azul Profundo - Segurança e Confiança
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#1E5F74", // Azul Petróleo - Tecnologia e Modernidade
      contrastText: "#FFFFFF",
    },
    warning: {
      main: "#F4A900", // Dourado Suave - Dinheiro e Prestígio
      contrastText: "#0A3D62",
    },
    text: {
      primary: "#0A3D62", // Azul Profundo - Para textos principais
      secondary: "#3A6978", // Dourado para destaques
    },
    background: {
      default: "#F8F9FA", // Fundo claro e limpo
      paper: "#FFFFFF", // Fundo de cartões e modais
    },
  },
});

export const ThemeProvider = ({children}: PropsWithChildren) => {
    return (
        <MuiThemeProvider theme={theme}>
            {children}
        </MuiThemeProvider>
    )
}